/*global google*/
/*global Waypoint*/
/*global notify*/
/*global inview*/
/*eslint no-undefined: 0*/
/*eslint no-unused-vars: 0*/
/*global form_contact*/

export default {
  ui: {
    init() {
      this.alertModal();
    },
    getCookie(name) {
      var dc = document.cookie;
      var prefix = name + '=';
      var begin = dc.indexOf('; ' + prefix);
      var end;
      if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) {
          return null;
        }
      } else {
        begin += 2;
        end = document.cookie.indexOf(';', begin);
        if (end === -1) {
          end = dc.length;
        }
      }
      // because unescape has been deprecated, replaced with decodeURI
      //return unescape(dc.substring(begin + prefix.length, end));
      return decodeURI(dc.substring(begin + prefix.length, end));
    },

    alertModal() {
      if ($('#global-modal').length && !this.getCookie('showed_alert_popup')) {
        $('#global-modal').modal('show');
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 3600000 * 24 * 1); // 1 day changed from 7 days
        document.cookie =
          'showed_alert_popup=true;expires=' + expire.toGMTString();
      }
    },
  },
  init() {
    // JavaScript to be fired on all pages

    $('.filter-clear').on('click', function () {
      let target = $(this).data('clear');
      console.log(target);

      $(target).each(function () {
        $(this).removeClass('selected');
        $(this).find('option:selected').removeAttr('selected');
      });
    });

    // Map Charts
    $('.map-chart').each(function () {
      let $fn_chart = this;
      console.log($fn_chart);
      let type = $(this).data('type');
      let type_colors = ['#fdb726', '#4d4b5a'];
      let trigger = 'none';
      let mapStyle = $(this).data('map-style');

      if (type === 'srp_states') {
        type_colors = ['#fef7e9', '#fdb726', '#c55002'];
        trigger = 'none';
      }

      let items = [['State', 'Status', { type: 'string', role: 'tooltip' }]];

      $($fn_chart)
        .find('.state-item')
        .each(function () {
          items.push([
            'US-' + $(this).data('name').toUpperCase(),
            $(this).data('state'),
            $(this).data('name').toUpperCase(),
          ]);
        });

      google.charts.load('current', {
        packages: ['geochart'],
        // Note: you will need to get a mapsApiKey for your project.
        // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
        mapsApiKey: 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY',
      });

      google.charts.setOnLoadCallback(drawRegionsMap);

      function drawRegionsMap() {
        let data = google.visualization.arrayToDataTable(items);

        let options = {
          region: 'US',
          resolution: 'provinces',
          legend: 'none',
          colorAxis: { colors: type_colors },
          tooltip: {
            trigger: trigger,
          },
          backgroundColor: {
            stroke: '#ffffff',
            fill: 'transparent',
          },
          sizeAxis: {
            minValue: 0,
            maxValue: 100,
          },
          displayMode: 'regions',
          keepAspectRatio: true,
          enableRegionInteractivity: true,
        };

        let chart = new google.visualization.GeoChart($fn_chart);

        if (type === 'srp_states') {
          google.visualization.events.addListener(chart, 'select', function () {
            var selection = chart.getSelection();
            var url = data.getValue(selection[0].row, 2);
            if(mapStyle == 'capacity_building') {
              $('#modal-' + url.toLowerCase()).modal();
            } else {
              window.location.href = '/srp_states/' + url;
            }
          });
        }

        chart.draw(data, options);
      }
    });

    // Donut Charts
    $('.donut-chart').each(function () {
      let $fn_donut_chart = this;
      let $data = $(this).find('.chart-data');
      let percentage = $data.data('percentage');
      let items = [
        ['Desc', 'Value'],
        ['', percentage],
        ['', 100 - percentage],
      ];

      // $($fn_donut_chart).find('.state-item').each(function () {
      //   items.push(['US-' + $(this).data('name').toUpperCase(), $(this).data('state')]);
      // });

      google.charts.load('current', {
        packages: ['corechart'],
      });

      google.charts.setOnLoadCallback(drawPieChart);

      function drawPieChart() {
        let data = google.visualization.arrayToDataTable(items);

        let options = {
          pieHole: 0.85,
          pieSliceText: 'none',
          backgroundColor: {
            stroke: 'transparent',
            fill: 'transparent',
          },
          pieSliceBorderColor: 'transparent',
          tooltip: { trigger: 'none' },
          slices: {
            0: { color: '#fdb726' },
            1: { color: '#ffffff' },
          },
          legend: {
            alignment: 'center',
            position: 'bottom',
          },
          chartArea: {
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: {
              stroke: 'transparent',
            },
          },
          animation: {
            startup: true,
            duration: 1000,
            easing: 'out',
          },
        };

        let chart = new google.visualization.PieChart($fn_donut_chart);

        chart.draw(data, options);
      }
    });

    // Bar Charts
    $('.bar-chart').each(function () {
      let $fn_bar_chart = this;
      let head = $(this).find('.heading.chart-data').data('val').split(', ');
      head.push({ role: 'annotation' });
      head.splice(2, 0, { role: 'annotation' });
      console.log(head);
      let items = [head];

      $($fn_bar_chart)
        .find('.chart-data.items')
        .each(function () {
          let item = $(this).data('val').split(', ');
          // console.log(item);
          // console.log(parseInt(item[2], 10));
          item = item.map((v) => (isNaN(v) ? v : parseInt(v, 10)));
          item.push(item[2] + '%');
          item.splice(2, 0, item[1] + '%');
          items.push(item);
        });

      // console.log(items);

      google.charts.load('current', {
        packages: ['corechart'],
      });

      google.charts.setOnLoadCallback(drawBarChart);

      function drawBarChart() {
        let barData = google.visualization.arrayToDataTable(items);

        let options = {
          width: '100%',
          height: 400,
          colors: ['#F56D34', '#9993B7'],
          bars: 'horizontal',
          animation: {
            startup: true,
            duration: 1000,
            easing: 'out',
          },
          annotations: {
            alwaysOutside: false,
            textStyle: {
              color: '#fff',
              fontName: 'farnam-display',
            },
            boxStyle: null,
          },
          tooltip: {
            trigger: 'none',
          },
          bar: {
            groupWidth: '90%',
          },
          legend: {
            position: 'top',
            textStyle: {
              color: '#ffffff',
              fontName: 'nimbus-sans',
            },
          },
          axisTitlesPosition: 'in',
          hAxis: {
            gridlines: {
              color: 'transparent',
              count: 0,
            },
            titleTextStyle: {
              color: '#ffffff',
              fontName: 'farnham-display',
              fontSize: 16,
            },
            baselineColor: 'transparent',
            texPosition: 'none',
          },
          vAxis: {
            gridlines: {
              color: 'transparent',
              count: 0,
            },
            minorGridlines: {
              color: 'transparent',
              count: 0,
            },
            textStyle: {
              color: '#ffffff',
              fontName: 'farnham-display',
              fontSize: 16,
            },
            texPosition: 'in',
            format: 'percent',
            baselineColor: 'transparent',
            ticks: [],
          },
          chartArea: {
            left: '25%',
            top: '10%',
            width: '100%',
            height: '100%',
          },
          isStacked: 'false',
          backgroundColor: 'transparent',
        };

        let chart = new google.visualization.BarChart($fn_bar_chart);
        google.visualization.events.addListener(chart, 'ready', function () {
          var labels = $fn_bar_chart.getElementsByTagName('text');
          Array.prototype.forEach.call(labels, function (label) {
            if (label.getAttribute('text-anchor') === 'end') {
              label.setAttribute('x', parseFloat(label.getAttribute('x')) - 10);
            }
          });
        });

        chart.draw(barData, options);
      }
    });

    // Waypoints for nav
    var inview = new Waypoint.Inview({
      element: $('#main-inner')[0],
      // enter: function (direction) {
      //   $('header.banner').toggleClass('enter');
      // },
      entered: function (direction) {
        if (direction === 'up') {
          $('header.banner').toggleClass('shorten');
        }
      },
      exit: function (direction) {
        if (direction === 'down') {
          $('header.banner').toggleClass('shorten');
        }
      },
      exited: function (direction) {},
    });

    console.log(form_contact);

    let phone = form_contact['phone']
      ? form_contact['phone']
      : '(202) 768-7338';
    let email = form_contact['email']
      ? form_contact['email']
      : 'info@freedomnetworkusa.org';

    $('.gform_wrapper').append(
      '<div class="form-footer"><hr /><div class="row"><div class="col-md-6"><h6 class="mb-0">Email Us</h6><p class="mb-2">' +
        email +
        '</p><h6 class="mb-0">Call Us</h6><p class="mb-2">' +
        phone +
        '</p></div><div class="col-md-6"><h6 class="mb-0">Mailing Address</h6><p class="mb-2">712 H St NE, Suite 1667<br />Washington, DC 20002</p></div></div></div>'
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    this.ui.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js